var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#349yuyk54a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.19 8.937.259-2.936h.33a1.157 1.157 0 0 0 1.12-1.19v-.648A1.144 1.144 0 0 0 17.78 3H4.12a1.143 1.143 0 0 0-1.12 1.163v.674A1.143 1.143 0 0 0 4.12 6h.33l1.225 13.852A1.159 1.159 0 0 0 6.82 21h8.259a.45.45 0 0 0 0-.9h-8.26a.26.26 0 0 1-.245-.27L5.274 5.1H4.12a.245.245 0 0 1-.22-.263v-.674a.245.245 0 0 1 .22-.263h13.66a.245.245 0 0 1 .22.263v.649a.276.276 0 0 1-.22.289h-1.155l-.33 3.747h-.02a4.696 4.696 0 0 0-2.44.68l.201-3.77a.451.451 0 0 0-.898-.06l-.243 4.579a4.711 4.711 0 0 0-.331 6.214l-.123 2.296a.45.45 0 1 0 .898.06l.08-1.513a4.723 4.723 0 1 0 3.771-8.397zm-.916 8.46a3.825 3.825 0 1 1 0-7.65c.07 0 .14.008.209.011.21.012.42.04.626.084a3.823 3.823 0 0 1-.835 7.556zM9.196 5.699l.698 13.089a.45.45 0 1 1-.898.06l-.698-13.09a.45.45 0 1 1 .899-.059zm8.625 6.143-1.516 3.757a.43.43 0 0 1-.376.279h-.027a.429.429 0 0 1-.384-.235l-.81-1.6a.429.429 0 0 1 .19-.58.43.43 0 0 1 .579.19l.368.729 1.167-2.835a.428.428 0 0 1 .6-.23.432.432 0 0 1 .21.525z",
    fill: "#383634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "349yuyk54a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 3)",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewDeleteIcon);
export default __webpack_public_path__ + "static/media/overview_delete_icon.41075d685c6149cee6b3bfcce47637dd.svg";
export { ForwardRef as ReactComponent };